<template>
<div @click="onItemClicked" class="flex flex-row border-l-6 border-grey-darkest items-center cursor-pointer hover:shadow:md">    
      <div class="flex flex-wrap">
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" viewBox="0 0 129 129" enable-background="new 0 0 129 129" width="30px" height="30px">
          <g>
            <g>
              <path d="m10.5,58.9h44.3c2.3,0 4.1-1.8 4.1-4.1v-44.3c0-2.3-1.8-4.1-4.1-4.1h-44.3c-2.3,0-4.1,1.8-4.1,4.1v44.3c0,2.2 1.9,4.1 4.1,4.1zm4.1-44.3h36.1v36.1h-36.1v-36.1z" fill="#3d4852"/>
              <path d="m122.6,10.5c0-2.3-1.8-4.1-4.1-4.1h-44.3c-2.3,0-4.1,1.8-4.1,4.1v44.3c0,2.3 1.8,4.1 4.1,4.1h44.3c2.3,0 4.1-1.8 4.1-4.1v-44.3zm-8.2,40.2h-36.1v-36.1h36.1v36.1z" fill="#3d4852"/>
              <path d="m10.5,122.6h44.3c2.3,0 4.1-1.8 4.1-4.1v-44.3c0-2.3-1.8-4.1-4.1-4.1h-44.3c-2.3,0-4.1,1.8-4.1,4.1v44.3c0,2.2 1.9,4.1 4.1,4.1zm4.1-44.3h36.1v36.1h-36.1v-36.1z" fill="#3d4852"/>
              <path d="m118.5,70.1h-44.3c-2.3,0-4.1,1.8-4.1,4.1v44.3c0,2.3 1.8,4.1 4.1,4.1h44.3c2.3,0 4.1-1.8 4.1-4.1v-44.3c0-2.2-1.9-4.1-4.1-4.1zm-4.1,44.3h-36.1v-36.1h36.1v36.1z" fill="#3d4852"/>
            </g>
          </g>
        </svg>
      </div>
      <div class="mx-3">
        <div class="flex text-grey-darkest leading-none font-semibold text-xl">Gallery</div>
      </div> 
    </div>
</template>

<script>
export default {
  name: "NavigationItemGallery",
  data() {
    return {
      isActive: false
    };
  },

  methods: {
    onItemClicked() {
      this.$root.$emit("onNavigateToGallery");
      console.log('hi there nav gallery')
    },
  },

  computed: {
    href() {
      //return "#" + this.title.toLowerCase().replace(/ /g, "-");
    }
  },
  mounted() {
    this.isActive = this.selected;
  }
};
</script>


// WEBPACK FOOTER //
// src/components/navigation/NavigationItemGallery.vue